import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AExpenseMasterComponent } from './aexpense-master/aexpense-master.component';
import { VendorComponent } from './vendor/vendor.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TransactionComponent } from './transaction/transaction.component';
import { ProductComponent } from './product/product.component';
import { AccountComponent } from './account/account.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/app/shared-module/shared.module';
import { OpeningBalanceComponent } from './opening-balance/opening-balance.component';
import { FileComponent } from './file/file.component';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { VoucherDetailsPopupComponent } from './voucher-details-popup/voucher-details-popup.component';
import { ShoppingBasketComponent } from './shopping-basket/shopping-basket.component';
import { NgxPrintModule } from 'ngx-print';
@NgModule({
  declarations: [AExpenseMasterComponent,VendorComponent,ProductComponent, AccountComponent, TransactionComponent
    ,ProductDetailsComponent, OpeningBalanceComponent, FileComponent, VoucherDetailsPopupComponent, ShoppingBasketComponent
   
  ],
  imports: [
    CommonModule,AgGridModule,NgbModule,RouterModule,FormsModule,BrowserAnimationsModule,SharedModule,ClipboardModule ,NgxMaskDirective, NgxMaskPipe,NgxPrintModule],
  exports: [AExpenseMasterComponent]
})
export class ExpenseManagerModule { }
